<template>
    <div class="p-8">
      <h1 class="text-2xl font-bold text-[#C59C2F] mb-6">All House Cleaning Orders</h1>

      <LoadingSpinner v-if="loading" />
      <ErrorMessage v-else-if="error" :message="error" />

      <div v-else>
        <OrderCard
          v-for="order in orders"
          :key="order.id"
          :order="order"
        />
      </div>
    </div>
  </template>

<script setup lang="ts">
import { ref, onMounted } from 'vue';

import fetchAllOrders from '@/service/order.service';
import ErrorMessage from '@/components/admin-dashboard/ErrorMessage.vue';
import LoadingSpinner from '@/components/admin-dashboard/LoadingSpinner.vue';
import OrderCard from '@/components/admin-dashboard/OrderCard.vue';

const orders = ref([]);
const loading = ref(true);
const error = ref('');

onMounted(async () => {
  try {
    const result = await fetchAllOrders();
    orders.value = result;
  } catch (err: any) {
    error.value = err.message || 'Failed to load orders';
  } finally {
    loading.value = false;
  }
});
</script>

<style lang="scss" scoped>
</style>
